import { useExpressionValue } from '../../../../expressions/render/hooks/useExpressionValue';
import { IConditionGroupExpression } from '../../../../expressions/repository/condition-group/IConditionGroupExpression';

/**
 * Hook per il calcolo dell'espressione booleana di un campo calcolato.
 * Gestisce la risoluzione dell'espressione e il tipo di ritorno.
 */
export function useBooleanExpressionValue(
  name: string,
  expression: IConditionGroupExpression,
) {
  const result = useExpressionValue(name, expression);

  return result.type === 'value' ? Boolean(result.result) : false;
}
